export default "__VITE_ASSET__f2163c5e__"